<template>
    <div :class="['reo-input-wrap', type]">
        <input type="text" :class="['reo-input', {'has-icon': icon}]" :value="data" :placeHolder="placeHolder" :readonly="readonly" @input="updateValue" spellcheck="false">
        <span v-if="icon" :class="['reo-input-icon', icon]"></span>
    </div>
</template>

<script>
export default {

    props: {
        
        value: String,
        icon: String,
        placeHolder: {

            type: String,
            default () {

                return '';

            }

        },
        readonly: String,
        type: String

    },

    data () {

        return {

            data: this.value

        };

    },

    methods: {

        updateValue ( e ) {

            let value = e.target.value;
            this.data = value;
            this.$emit( 'input', value );

        }

    },

    watch: {

        value ( value ) {

            this.data = value;

        }
    }

};
</script>

<style>
.reo-input-wrap{
    position: relative;
    width: 3.3rem;
    display: inline-block;
    color: #fff;
}
.reo-input-wrap.gray .reo-input{
    color: #333;
    border-color: #ccc;
    background: #fff;
}
.reo-input{
    font-size: 0.16rem;
    border-width: 1px;
    border-radius: 0.3rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    height: 0.48rem;
    width: 100%;
    box-sizing: border-box;
    font-weight: 500;
    color: white;
    background: transparent;
    border: 1px solid white;
}
.reo-input.has-icon{
    padding-left: 0.6rem;
}
.reo-input:hover,
.reo-input:focus{
    border-color: #fff;
}
.reo-input-icon{
    position: absolute;
    left: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.3rem;
}
.reo-input-wrap ::-webkit-input-placeholder {
    color:#fff;
}
.reo-input-wrap :-moz-placeholder {
    color:#fff;
}
.reo-input-wrap ::-moz-placeholder {
    color:#fff;
}
.reo-input-wrap :-ms-input-placeholder {
    color:#fff;
}
.reo-input-wrap.gray ::-webkit-input-placeholder {
    color:#333;
}
.reo-input-wrap.gray :-moz-placeholder {
    color:#333;
}
.reo-input-wrap.gray ::-moz-placeholder {
    color:#333;
}
.reo-input-wrap.gray :-ms-input-placeholder {
    color:#333;
}
@media screen and (max-width:1199px) {
    .reo-input{
        height: 0.78rem;
        font-size: 0.26rem;
        border-radius: 0.45rem;
        padding: 0 .5rem !important;
        text-align: center;
    }
    .reo-input-icon{
        display: none;
    }
    .reo-input-wrap{
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/Input.vue